import React, { Fragment, useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import GamesService from 'services/GamesService'
import Spinner from 'ui/Spinner'
import { BACKGROUNDS } from 'themes'
import Icon from 'ui/Icon'
import starActiveIcon from 'icons/star_active.svg'
import infoIcon from 'icons/info.svg'
import { ModalService } from 'services/ModalService'
import getTexts from 'utils/localization'
import { detectMobile } from 'common/adapters/DeviceDetectAdapter'
import NotificationConductor from 'common/conductors/NotificationConductor'
import { csIds } from 'utils/tracking'

const t = getTexts()

const IconWrapper = styled.div`
    width: 32px;
    height: 32px;
    display: block;
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: ${(props) => (props.position === 'top' ? '5px' : 'initial')};
    bottom: ${(props) => (props.position === 'bottom' ? '5px' : 'initial')};
    transition: all 0.3s ease;
    border-radius: 5px;
    padding: 5px;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(30px);
    text-align: center;
    z-index: 1;
    opacity: 1;

    body.hasHover &:hover {
        svg {
            transition: all 0.3s ease;
            transform: scale(1.15);
        }
    }
`

const ServiceButtons = ({
    showInfoIcon = true,
    showFavoriteButton = true,
    favorite = true,
    game = {},
    isUserLoggedIn = false,
}) => {
    const [favoriteGames, setFavoriteGames] = useState([])
    const [isFavorite, setIsFavorite] = useState(favorite)
    const [isLoading, setIsLoading] = useState(false)

    const checkFavorite = () =>
        favoriteGames.map((e) => e.game_id).indexOf(game.game_id) >= 0

    const showGamePopup = (e) => {
        e.preventDefault()
        e.stopPropagation()
        ModalService.showModal('GAME_POPUP', {
            game,
            favorite: isFavorite,
            backUrl: window.location.href,
        })
        window.history.pushState('', '', '/spil/info/' + game.game_id)
    }

    const ToggleLike = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsLoading(true)
        if (isUserLoggedIn) {
            checkFavorite()
                ? GamesService.gameUnLike(game.game_id).then(() => {
                      GamesService.fetchFavorite()
                      setIsLoading(false)
                  })
                : GamesService.gameLike(game.game_id).then(() => {
                      GamesService.fetchFavorite()
                      setIsLoading(false)
                  })
        } else {
            setIsLoading(false)
            NotificationConductor.error(t.loginForFavorites)
        }
    }

    const TooltipProps = () =>
        !detectMobile()
            ? {
                  'data-for': 'game-info',
                  'data-effect': 'solid',
                  'data-place': 'bottom',
                  onMouseOver: (e) => {
                      ReactTooltip.rebuild()
                  },
                  onMouseLeave: (e) => {
                      ReactTooltip.hide()
                  },
              }
            : null

    useEffect(
        () => {
            setIsFavorite(checkFavorite(game.game_id))
        },
        [favoriteGames]
    )

    useEffect(() => {
        const subscription = GamesService.getFavoriteGames().subscribe(
            (res) => {
                if (res) {
                    setFavoriteGames(res)
                }
                setIsFavorite(checkFavorite(game.game_id))
            }
        )

        return () => {
            subscription.unsubscribe()
        }
    }, [])

    return (
        <Fragment>
            {showFavoriteButton && (
                <IconWrapper
                    onClick={(e) => {
                        ToggleLike(e)
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    position={'top'}
                    data-cs-id={
                        checkFavorite()
                            ? csIds.gameCard.removeFavorite
                            : csIds.gameCard.addFavorite
                    }
                >
                    {isLoading ? (
                        <Spinner
                            width="20px"
                            height="20px"
                            color={BACKGROUNDS.white}
                        />
                    ) : (
                        <Icon
                            height="16px"
                            width="16px"
                            color={
                                checkFavorite()
                                    ? BACKGROUNDS.accent
                                    : BACKGROUNDS.white
                            }
                            data-tip={
                                isFavorite
                                    ? t.gameTooltip.favorite.remove
                                    : t.gameTooltip.favorite.add
                            }
                            {...TooltipProps()}
                            src={starActiveIcon}
                        />
                    )}
                </IconWrapper>
            )}

            {showInfoIcon && (
                <IconWrapper
                    onClick={showGamePopup}
                    position={'bottom'}
                    data-cs-id={csIds.gameCard.infoBtn}
                >
                    <Icon
                        height="16px"
                        width="16px"
                        color={BACKGROUNDS.white}
                        src={infoIcon}
                        data-tip={t.gameTooltip.info}
                        {...TooltipProps()}
                    />
                </IconWrapper>
            )}
        </Fragment>
    )
}

export default ServiceButtons
